import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { ITuple } from '@app/_models/tuple';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { NzDrawerRef, NzOptionComponent, UploadFile } from 'ng-zorro-antd';
import { AssetHistory, AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetViewModel } from '@app/_models/_viewModels/asset.viewmodel';
import { LocationService } from '@app/_services/location.service';
import { DepartmentService } from '@app/_services/department.service';
import { SupplierService } from '@app/_services/supplier.service';
import { EmployeeService } from '@app/_services/employee.service';
import { AssetGroup } from '@app/_models/_DTOs/assetGroup';
import { AssetGroupService } from '@app/_services/assetGroup.service';
import { Department } from '@app/_models/_DTOs/department';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { Employee } from '@app/_models/_DTOs/employee';
import { AssetType } from '@app/_models/enums/assetType';
import { map } from 'rxjs/internal/operators/map';

import { NzMessageService } from 'ng-zorro-antd';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Media } from '@app/_models/_DTOs/media';
import { Subject } from 'rxjs';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { AssetDetailsComponent } from '@app/assets/asset-details/asset-details.component';
import { ResizeService } from '@app/_services/resize.service';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AssetEditorComponent } from '@app/assets/asset-editor/asset-editor.component';
import { Sort } from '@app/_models/sort';
import { SortDirection } from '@app/_models/enums/sortDirection';
import { InventoryFoundAsset } from '@app/_models/_DTOs/inventoryFoundAsset';
import { InventoryFoundAssetService } from '@app/_services/inventoryFoundAsset.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Inventory } from '@app/_models/_DTOs/inventory';
import { InventoryService } from '@app/_services/inventory.service';
import { FoundAssetDetailsComponent } from '@app/found-asset-details/found-asset-details.component';
import { AssetDiscardProposal } from '@app/_models/_DTOs/assetDiscardProposal';
import { AssetService } from '@app/_services';
import { MultiDiscardActionViewModel } from '@app/_models/_viewModels/multiAssetDiscard.viewmodel';
import { UserService } from '@app/_services/user.service';
import { User } from '@app/_models/_DTOs/user';
import { DiscardActionViewModel } from '@app/_models/_viewModels/discardAction.viewmodel';
import { AssetDiscardViewModel } from '@app/_models/_viewModels/assetDiscard.viewmodel copy';
import { RemoveDiscardProposalViewModel } from '@app/_models/_viewModels/removeDiscardProposal.viewmodel';

@Component({
  selector: 'app-discard-recommendations',
  templateUrl: './discard-recommendations.component.html',
  styleUrls: ['./discard-recommendations.component.css']
})

export class DiscardRecommendationsComponent implements OnInit {

  level: number = 0;

  sorts: Sort[] = [];
  pageIndex = 1;
  pageSize = 10;
  total = 1;
  assetList: AssetDiscardProposal[] = [];
  loading = true;
  isDiscardingAsset: boolean = false;

  locations: Location[] = [];
  // filteredLocations: Location[] = [];
  assetGroups: AssetGroup[] = [];
  departments: Department[] = [];
  suppliers: Supplier[] = [];
  employees: Employee[] = [];
  inventories: Inventory[] = [];
  users: User[] = [];

  isDiscardModalOpen: boolean = false;
  isSingleDiscardModalOpen: boolean = false;

  @ViewChild(FoundAssetDetailsComponent, { static: false })
  private foundAssetDetailsComponent: FoundAssetDetailsComponent;

  selectedEmployee: Employee;

  selectedLocation: Location;

  nameSearchValue = "";
  inventoryCodeSearchValue = "";
  inventoryIdSearchValue: number[] = [];
  departmentIdSearchValue: number[] = [];
  employeeIdSearchValue: number[] = [];
  locationIdSearchValue: number[] = [];
  assetTypeSearchValue: number[] = [];
  assetGroupSearchValue: number[] = [];
  supplierIdSearchValue: number[] = [];

  public assetHistoryActionType = AssetHistoryActionType;
  public assetTypes = AssetType;

  isAllDisplayDataChecked = false;
  isOperating = false;
  isIndeterminate = false;
  mapOfCheckedId: { [key: string]: boolean } = {};
  numberOfChecked = 0;

  multiDiscardActionViewModel: MultiDiscardActionViewModel = null;

  discardActionViewModel: DiscardActionViewModel = null;

  apiUrl: string;

  screenSize: SCREEN_SIZE;

  errorMessages = {};

  public filterTimerStarted = false;
  public filterTimer;

  constructor(
    private assetService: AssetService,
    private breakpointObserver: BreakpointObserver,
    private locationService: LocationService,
    private departmentService: DepartmentService,
    private supplierService: SupplierService,
    private employeeService: EmployeeService,
    private assetGroupService: AssetGroupService,
    private inventoryService: InventoryService,
    private router: Router,
    private messageService: NzMessageService,
    private route: ActivatedRoute,
    private resizeService: ResizeService,
    private userService: UserService,
    private documentService: DocumentService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe(size => {
      this.screenSize = size;
    });
  }

  ngOnInit() {
    this.loadDataForDropdowns();

    this.route.queryParams.subscribe(params => {
      let inventoryId = params['inventoryId'];
      if (inventoryId != undefined) {
        this.inventoryIdSearchValue.push(inventoryId);
      }
    });
    this.searchData(true);
    if (this.resizeService.currentSize != null) {
      this.screenSize = this.resizeService.currentSize;
    }
  }

  loadDataForDropdowns() {
    this.departmentService.getAllBasic().subscribe((data: Department[]) => {
      this.departments = data;
    });
    this.employeeService.getAllBasic().subscribe((data: Employee[]) => {
      this.employees = data;
    });
    this.locationService.getAllBasic().subscribe((data: Location[]) => {
      this.locations = data;
    });
    this.assetGroupService.getAllBasic().subscribe((data: AssetGroup[]) => {
      this.assetGroups = data;
    });
    this.supplierService.getAllBasic().subscribe((data: Supplier[]) => {
      this.suppliers = data;
    });
    this.inventoryService.getAllBasic().subscribe((data: Inventory[]) => {
      this.inventories = data;
    });
    this.userService.getAllBasic().subscribe((data: User[]) => {
      this.users = data;
    });
  }

  sort(sort: { key: string; value: string }): void {
    var newSort: Sort = {
      PropertyName: sort.key,
      Direction: null
    };
    if (sort.value) {
      if (sort.value == "ascend") {
        newSort.Direction = SortDirection.Ascending;
      }
      else {
        newSort.Direction = SortDirection.Descending;
      }
    }

    if (newSort.Direction == null) {
      var existingSort = this.sorts.find(x => x.PropertyName == newSort.PropertyName);
      if (existingSort) {
        const index = this.sorts.indexOf(existingSort);
        if (index > -1) {
          this.sorts.splice(index, 1);
        }
      }
    }
    else {
      var existingSort = this.sorts.find(x => x.PropertyName == newSort.PropertyName);
      if (existingSort) {
        existingSort.Direction = newSort.Direction;
      }
      else {
        this.sorts.push(newSort);
      }
    }
    this.searchData();
  }

  getSortString() {
    var sortString = "";
    if (this.sorts && this.sorts.length > 0) {
      for (let sort of this.sorts) {
        if (sort.Direction == SortDirection.Ascending) {
          if (sortString.length == 0) {
            sortString = sort.PropertyName;
          }
          else {
            sortString += "," + sort.PropertyName;
          }
        }
        else {
          if (sortString.length == 0) {
            sortString = "-" + sort.PropertyName;
          }
          else {
            sortString += ",-" + sort.PropertyName;
          }
        }
      }
    }
    return sortString;
  }

  getFilters(){
    var filters = "";
    if (this.nameSearchValue.length > 0) {
      filters += "Asset.Name@=" + this.nameSearchValue + ",";
    }
    if (this.inventoryCodeSearchValue.length > 0) {
      filters += "Asset.InventoryCode@=" + this.inventoryCodeSearchValue + ",";
    }
    if (this.departmentIdSearchValue.length > 0) {
      filters += "Asset.DepartmentId==" + this.departmentIdSearchValue.join("|") + ",";
    }
    if (this.employeeIdSearchValue.length > 0) {
      filters += "Asset.EmployeeId==" + this.employeeIdSearchValue.join("|") + ",";
    }
    if (this.locationIdSearchValue.length > 0) {
      filters += "Asset.LocationId==" + this.locationIdSearchValue.join("|") + ",";
    }
    if (this.assetTypeSearchValue.length > 0) {
      filters += "Asset.Type==" + this.assetTypeSearchValue.join("|") + ",";
    }
    if (this.inventoryIdSearchValue.length > 0) {
      filters += "Inventory.Id==" + this.inventoryIdSearchValue.join("|") + ",";
    }
    return filters;
  }

  getSort(){
    var sortString = this.getSortString();
    if (sortString.length == 0) {
      sortString = "-Created";
    } else {
      sortString += ",-Created";
    }
    return sortString;
  }

  searchData(reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }
    
    var filters = this.getFilters();
    var sortString = this.getSort();

    this.loading = true;
    this.assetService
      .getAssetsForDiscarding(this.pageIndex, this.pageSize, sortString, filters)
      .subscribe((data: ITuple<AssetDiscardProposal>) => {
        this.loading = false;
        this.total = data.item2;
        this.assetList = data.item1;
      });
  }

  exportExcel(){
    var filters = this.getFilters();
    var sortString = this.getSort();
    this.assetService
    .getAssetsForDiscardingExcel(sortString, filters)
    .subscribe(
      (result) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(result);
        }
        else {
          var fileUrl = URL.createObjectURL(result);

          var anchor = document.createElement("a");
          anchor.download = "Prijedlozi za rashod.xlsx";
          anchor.href = fileUrl;
          anchor.click();
        }
      });
  }

  reset(): void {
    this.nameSearchValue = '';
    this.inventoryCodeSearchValue = '';
    this.departmentIdSearchValue = [];
    this.employeeIdSearchValue = [];
    this.locationIdSearchValue = [];
    this.assetTypeSearchValue = [];
    this.assetGroupSearchValue = [];
    this.supplierIdSearchValue = [];
    this.inventoryIdSearchValue = [];
    this.searchData(true);
  }

  openDetails(asset: Asset) {
    this.foundAssetDetailsComponent.loadAsset(asset.id);
  }

  closeDetails() {
    this.foundAssetDetailsComponent.selectedAsset = null;
    this.foundAssetDetailsComponent.isOpen = false;
  }

  openEmployeeDetails(employee: Employee) {
    this.employeeService
      .get(employee.id)
      .subscribe((data: Employee) => {
        this.selectedEmployee = data;
      });
  }

  openLocationDetails(location: Location) {
    this.locationService
      .get(location.id)
      .subscribe((data: Location) => {
        this.selectedLocation = data;
      })
  }

  closeEmployeeDetails() {
    this.selectedEmployee = null;
  }

  closeLocationDetails() {
    this.selectedLocation = null;
  }

  public getActionTypeName(actionType: AssetHistoryActionType) {
    return AssetHistoryActionName.get(actionType).name;
  }

  public getAssetTypeName(assetType: AssetType) {
    return AssetTypeName.get(assetType);
  }

  public assetTypeKeys() {
    var keys = Object.keys(this.assetTypes);
    return keys.slice(keys.length / 2);
  }

  refreshStatus(clickedId?: number): void {
    this.isAllDisplayDataChecked = this.assetList
      .every(item => this.mapOfCheckedId[item.inventoryAssetAction.id] == true) && Object.keys(this.mapOfCheckedId).length > 0;
    this.isIndeterminate =
      this.assetList.some(item => this.mapOfCheckedId[item.inventoryAssetAction.id]) && !this.isAllDisplayDataChecked;
    this.numberOfChecked = this.assetList.filter(item => this.mapOfCheckedId[item.inventoryAssetAction.id]).length;
  }

  checkAll(value: boolean): void {
    this.assetList.forEach(item => (this.mapOfCheckedId[item.inventoryAssetAction.id] = value));

    this.refreshStatus();
  }

  discardAssets(form: NgForm) {
    this.isDiscardingAsset = true;
    this.assetService.discardAssets(this.multiDiscardActionViewModel).subscribe(result => {
      this.messageService.create("success", "Rashod uspješno proveden");
      this.isDiscardingAsset = false;
      this.searchData(true);
      this.closeDiscardModal();
      if (result.type == 'application/pdf') {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        }
        else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, '_blank');
        }
      }
      else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    }, error => {
      if (error.ParamName) {
        if (form.controls[error.ParamName]) {
          form.controls[error.ParamName].setErrors({ custom: true });
          var errorMessage = error.Message.split("Parameter name")[0];
          this.errorMessages[error.ParamName] = errorMessage;
        }
      }
      this.isDiscardingAsset = false;
    });
  }

  discardAsset(form: NgForm) {
    this.isDiscardingAsset = true;
    this.assetService.discardAsset(this.discardActionViewModel).subscribe(result => {
      this.messageService.create("success", "Rashod uspješno proveden");
      this.isDiscardingAsset = false;
      this.searchData(true);
      this.closeSingleDiscardModal();
      if (result.type == 'application/pdf') {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        }
        else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, '_blank');
        }
      }
      else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    }, error => {
      if (error.ParamName) {
        if (form.controls[error.ParamName]) {
          form.controls[error.ParamName].setErrors({ custom: true });
          var errorMessage = error.Message.split("Parameter name")[0];
          this.errorMessages[error.ParamName] = errorMessage;
        }
      }
      this.isDiscardingAsset = false;
    });
  }

  openDiscardModal() {
    let discardProposals = this.assetList.filter(item => this.mapOfCheckedId[item.inventoryAssetAction.id]);
    this.multiDiscardActionViewModel = {
      assetsForDiscard: discardProposals.map<AssetDiscardViewModel>(discardProposal => {
        let assetDiscardViewModel: AssetDiscardViewModel = {
          id: -1,
          assetId: discardProposal.asset.id,
          inventoryAssetActionId: discardProposal.inventoryAssetAction.id
        }
        return assetDiscardViewModel;
      }),
      id: -1,
      remark: ""
    };

    this.isDiscardModalOpen = true;
  }

  closeDiscardModal() {
    this.multiDiscardActionViewModel = null;
    this.isDiscardModalOpen = false;
    this.checkAll(false);
  }

  openSingleDiscardModal(discardProposal: AssetDiscardProposal) {
    this.discardActionViewModel = {
      id: -1,
      assetId: discardProposal.asset.id,
      remark: "",
      inventoryAssetActionId: discardProposal.inventoryAssetAction.id
    };

    this.isSingleDiscardModalOpen = true;
  }

  closeSingleDiscardModal() {
    this.discardActionViewModel = null;
    this.isSingleDiscardModalOpen = false;
  }

  removeDiscardProposal(discardProposal: AssetDiscardProposal) {
    let viewModel: RemoveDiscardProposalViewModel = {
      inventoryAssetActionId: discardProposal.inventoryAssetAction.id
    };
    this.inventoryService.removeAssetDiscardProposal(viewModel).subscribe(result => {
      this.messageService.create("success", "Prijedlog za rashod uklonjen");
      this.searchData(true);

    }, error => {
      this.messageService.create("error", "Pokušajte ponovno.");
    });
  }

}
